import { render } from "./Checkout.vue?vue&type=template&id=67073a9e"
import script from "./Checkout.vue?vue&type=script&lang=js"
export * from "./Checkout.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/configuration/Checkout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67073a9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67073a9e', __exports__)) {
    console.log('reload')
    api.reload('67073a9e', __exports__)
  }
  
  module.hot.accept("./Checkout.vue?vue&type=template&id=67073a9e", () => {
    console.log('re-render')
    api.rerender('67073a9e', render)
  })

}


export default __exports__